<template>
  <div>
    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <h3>{{$t('form.tender.lots-in-tender')}}</h3>
    </div>
    <div class="admin__a-tab-content admin__a-tab-content--show">
      <div class="a-ui-tab">
        <div class="a-ui-tab__block" v-for="(lot, idx) in tender.lots">
          <div class="a-ui-tab__control-panel">
            <div class="a-ui-tab__control">
              <div class="a-ui-tab__arrow"></div>
              <div class="a-ui-tab__number-block">{{idx + 1}}</div>
              <div class="a-ui-tab__title">
                <router-link tag="button"
                             class="gui-btn gui-btn--link"
                       :to="{name: 'purchases-my-lots-details', params: { lotId: lot.id, tab: 'overview'}}">
                  {{$t('form.tender.lot-title', {number: lot.identifier})}}
                </router-link>
              </div>
            </div>
          </div>
          <div class="a-ui-tab__content-block">
            <div class="a-ui-tab__content">
              <div class="a-container-form ">
                <div class="a-label a-label--w-220">{{$t('labels.lot-name')}}</div>
                <p class="a-input a-input--disabled">{{lot.name}}</p>
              </div>

              <div class="a-container-form ">
                <div class="a-label a-label--w-220">{{$t('labels.price')}}</div>
                <p class="a-input a-input--disabled">{{lot.price | price}} {{$t(lot.currency.label)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tender: Object
    }
  }
</script>

<style scoped>

</style>
